import { Card as BaseCard } from 'antd';
import styled from 'styled-components';

export const Card = styled(BaseCard)`
  min-width: 120px;
  border-radius: 8px;
  text-align: center;
  font-weight: 600;
`;
